import React from "react";
import { FaSearch } from "react-icons/fa";
import Titulo from "../../../titulo/Titulo";
import { ModalDesignacaoProvider, useModalDesignacaoContext } from "./providers";
import { ModalContent, PaginationControls } from "./components";
import {
  Overlay,
  ModalBox,
  ModalHeader,
  TopBar,
  PageInfo,
  SearchBox,
  SearchInput,
  FilterSelect,
  SectionTitle,
  CardListScroll,
  PaginationBar,
  CloseButton,
} from "./style/ModalDesignacao.styles";

// ============================================================================
// COMPONENTE INTERNO (consome o context)
// ============================================================================

const ModalDesignacaoContent = ({ onClose, onSelectPublicador, pontoSelecionado }) => {
  const {
    carregando,
    search,
    filtroDisponibilidade,
    handleFilterChange,
    ultimasDesignacoes,
    limitesFrequencia,
    disponibilidadeSemana,
    ausenciasSelecionadas,
    paginationData,
    selecionados,
    togglePublicador,
    handleNextPage,
    handlePrevPage,
    handleSearch,
  } = useModalDesignacaoContext();

  const { currentPageItems, displayPage, displayTotalPages, hasNextPage, hasPrevPage, totalItems } = paginationData;

  return (
    <Overlay>
      <ModalBox>
        <ModalHeader>
          <Titulo>Selecionar Publicador</Titulo>
          <TopBar>
            <PageInfo>
              Página: <b>{displayPage}</b> de <b>{displayTotalPages}</b>
            </PageInfo>
            <div>
              <FilterSelect
                value={filtroDisponibilidade}
                onChange={(e) => handleFilterChange(e.target.value)}
              >
                <option value="Todos">Todos</option>
                <option value="Disponíveis">Disponíveis</option>
                <option value="Indisponíveis">Indisponíveis</option>
              </FilterSelect>
              <SearchBox>
                <SearchInput
                  placeholder="Pesquisar"
                  value={search}
                  onChange={(e) => handleSearch(e.target.value)}
                />
                <FaSearch style={{ color: "#888", fontSize: 15 }} />
              </SearchBox>
            </div>
          </TopBar>
        </ModalHeader>

        <CardListScroll>
          <ModalContent
            carregando={carregando}
            pontoSelecionado={pontoSelecionado}
            currentPageItems={currentPageItems}
            ultimasDesignacoes={ultimasDesignacoes}
            limitesFrequencia={limitesFrequencia}
            disponibilidadeSemana={disponibilidadeSemana}
            ausenciasSelecionadas={ausenciasSelecionadas}
            selecionados={selecionados}
            togglePublicador={togglePublicador}
          />
        </CardListScroll>

        {pontoSelecionado && (
          <PaginationBar>
            <PageInfo>
              {totalItems} {totalItems === 1 ? 'publicador' : 'publicadores'}
            </PageInfo>
            <PaginationControls
              pontoSelecionado={pontoSelecionado}
              hasPrevPage={hasPrevPage}
              hasNextPage={hasNextPage}
              onPrevPage={handlePrevPage}
              onNextPage={handleNextPage}
            />
          </PaginationBar>
        )}

        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '16px 28px', borderTop: '1px solid #eee' }}>
          <button
            onClick={() => onSelectPublicador(selecionados)}
            disabled={selecionados.length === 0}
            style={{
              padding: '10px 20px',
              border: 'none',
              borderRadius: '8px',
              backgroundColor: selecionados.length > 0 ? '#00aaaa' : '#ccc',
              color: '#fff',
              fontSize: '14px',
              cursor: selecionados.length > 0 ? 'pointer' : 'not-allowed',
            }}
          >
            Confirmar ({selecionados.length})
          </button>
        </div>

        <CloseButton onClick={onClose}>&#10005;</CloseButton>
      </ModalBox>
    </Overlay>
  );
};

// ============================================================================
// COMPONENTE PRINCIPAL (Provider wrapper)
// ============================================================================

const ModalDesignacao = ({
  open,
  onClose,
  onSelectPublicador,
  horariosSelecionados = [],
  diaSelecionado = null,
  pontoSelecionado = null,
  dataSelecionada = null,
}) => {
  if (!open) return null;

  return (
    <ModalDesignacaoProvider
      open={open}
      horariosSelecionados={horariosSelecionados}
      diaSelecionado={diaSelecionado}
      pontoSelecionado={pontoSelecionado}
      dataSelecionada={dataSelecionada}
    >
      <ModalDesignacaoContent
        onClose={onClose}
        onSelectPublicador={onSelectPublicador}
        pontoSelecionado={pontoSelecionado}
      />
    </ModalDesignacaoProvider>
  );
};

export default ModalDesignacao;
